import { getGoogleMapsAddressUrl } from 'utils/shared/location/getGoogleMapsAddressUrl';
import Directions from 'svg/Directions';
import Link from 'components/Link';
import classNames from 'styles/utils/classNames';

interface Props {
  address: string;
  isActive: boolean;
  onSelect: () => void;
}

/** One row of the address list below the map. The selected row lifts off the page
 *  with a ring and a shadow rather than a fill, per the design. */
export default function AddressSelectionCard({ address, isActive, onSelect }: Props) {
  return (
    <div
      className={classNames(
        'relative box-border flex w-full shrink-0 cursor-pointer flex-col content-stretch items-start justify-center gap-2.5 overflow-clip rounded-lg p-3 transition-all',
        isActive &&
          'shadow-[0px_0px_0px_2px_#ffffff,0px_0px_0px_3px_#B9B9BE,0px_4px_20px_0px_rgba(0,0,0,0.16)]',
      )}
      onClick={onSelect}
    >
      <div className="relative box-border flex w-full shrink-0 content-stretch items-start justify-center gap-1.5 rounded-2xl p-0">
        <div className="relative size-5 shrink-0 overflow-clip">
          <Link className="block" isExternal href={getGoogleMapsAddressUrl(address)}>
            <Directions className={classNames('h-5 w-5', isActive && 'text-color-brand-primary')} />
          </Link>
        </div>
        <div
          className={classNames(
            'relative min-h-px min-w-px shrink-0 grow basis-0 text-base font-medium not-italic leading-[0]',
            isActive
              ? 'text-color-brand-primary'
              : 'text-color-text-lightmode-primary dark:text-color-text-darkmode-primary',
          )}
        >
          <p className="block leading-[1.2]">{address}</p>
        </div>
      </div>
    </div>
  );
}
